import { __decorate, __metadata } from "tslib";
import { UseRestraints } from '@core/shared/restraints';
import { CrudEndpoints, EditorDefinition, Expose, IdItemModel, ItemModelDefinition, ItemModelProp, Trim, ValidateNested, ModelId, Structure } from '@core/shared/model';
import { ExamQuestionItem } from './exam-question.item';
import { ExamRestraints } from './exam.restraints';
let ExamItem = /*#__PURE__*/(() => {
  let ExamItem = class ExamItem extends IdItemModel {
    toString() {
      return "Exam " + this.name;
    }
  };
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Number)], ExamItem.prototype, "courseId", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], ExamItem.prototype, "enabled", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), __metadata("design:type", String)], ExamItem.prototype, "name", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], ExamItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], ExamItem.prototype, "updateDate", void 0);
  __decorate([Expose(), Structure(Array, () => ExamQuestionItem), ValidateNested(), ItemModelProp({
    defaultValueCreate: []
  }) // must be empty, else child entity validation would fail!
  , __metadata("design:type", Array)], ExamItem.prototype, "questions", void 0);
  ExamItem = __decorate([EditorDefinition('admin', {
    courseId: 'readonly',
    enabled: true,
    questions: {
      loadDefinition: 'admin'
    }
  }, {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/courses/exams'
  }), UseRestraints(ExamRestraints), ItemModelDefinition({
    texts: {
      item: 'Prüfung',
      items: 'Prüfungen'
    }
  }), ModelId("ExamItem") // auto-generated by generate-model-ids
  ], ExamItem);
  return ExamItem;
})();
export { ExamItem };